// Caminho do arquivo: src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// ATENÇÃO: Substitua este objeto pelo seu firebaseConfig real
// que você copiou do console do Firebase.
const firebaseConfig = {
  apiKey: "AIzaSyAYpVWGVJtP_t5ICncoiwcHkHa8cfyfQ4M",
  authDomain: "cabeleireirohulk.firebaseapp.com",
  projectId: "cabeleireirohulk",
  storageBucket: "cabeleireirohulk.firebasestorage.app",
  messagingSenderId: "894319735562",
  appId: "1:894319735562:web:5f0fc045d07cf36f8040f3",
  measurementId: "G-XJG6CVGRB4"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);